import * as React from 'react';

import styles from './status-selector.module.css';

type Props = {
    color: string;
    size?: number;
};

export function StatusDot(props: Props) {
    const {color, size = 12} = props;

    return (
        <div
            style={{
                backgroundColor: color,
                width: `${size}px`,
                height: `${size}px`,
            }}
            className={styles['status-dot']}
        />
    );
}
